import React, { useEffect, useState } from "react"

export function MeTypeComponent() {
  useEffect(() => {
    const loadDynamicScript = () => {
      const script = document.createElement("script")
      script.src = "https://www.metype.com/quintype-metype/assets/metype.js" // URL for the third-party library being loaded.
      script.id = "metype"
      document.body.appendChild(script)

      script.onload = () => {
        const talktype =
          talktype ||
          function (f) {
            if (window.talktype.loaded) f()
            else (window.talktype.q = window.talktype.q || []).push(arguments)
          }

        talktype(function () {
          var pageUrl = window.location.href
          var accountId = "1000426"
          var metypeHost = "https://www.metype.com/"
          window.talktype.pageMetadataSetter(accountId, pageUrl, metypeHost)
        })

        const metypeContainer = document.getElementById("metype-container"),
          page_url = metypeContainer.getAttribute("data-metype-page-url")
        metypeContainer.setAttribute(
          "data-metype-page-url",
          page_url || window.location.href
        )
        metypeContainer.setAttribute(
          "data-metype-window-height",
          window.innerHeight
        )
        metypeContainer.setAttribute(
          "data-metype-screen-width",
          window.screen.width
        )
        talktype(function () {
          window.talktype.commentWidgetIframe(metypeContainer)
        })
      }
    }

    loadDynamicScript()
  }, [])

  return (
    <div style={{ margin: "0 auto", marginTop: "2rem", maxWidth: "700px" }}>
      <div
        id="metype-container"
        class="iframe-container"
        data-metype-account-id="1000426"
        data-metype-host="https://www.metype.com/"
        data-metype-primary-color="#0000ff"
        data-metype-bg-color="#ffffff"
        data-metype-font-color="#4a4a4a"
      ></div>
    </div>
  )
}

// Hook
let cachedScripts = []
function useScript(src) {
  // Keeping track of script loaded and error state
  const [state, setState] = useState({
    loaded: false,
    error: false,
  })

  useEffect(
    () => {
      // If cachedScripts array already includes src that means another instance ...
      // ... of this hook already loaded this script, so no need to load again.
      if (cachedScripts.includes(src)) {
        setState({
          loaded: true,
          error: false,
        })
      } else {
        cachedScripts.push(src)

        // Create script
        let script = document.createElement("script")
        script.src = src
        script.async = true

        // Script event listener callbacks for load and error
        const onScriptLoad = () => {
          setState({
            loaded: true,
            error: false,
          })
        }

        const onScriptError = () => {
          // Remove from cachedScripts we can try loading again
          const index = cachedScripts.indexOf(src)
          if (index >= 0) cachedScripts.splice(index, 1)
          script.remove()

          setState({
            loaded: true,
            error: true,
          })
        }

        script.addEventListener("load", onScriptLoad)
        script.addEventListener("error", onScriptError)

        // Add script to document body
        document.body.appendChild(script)

        // Remove event listeners on cleanup
        return () => {
          script.removeEventListener("load", onScriptLoad)
          script.removeEventListener("error", onScriptError)
        }
      }
    },
    [src] // Only re-run effect if script src changes
  )

  return [state.loaded, state.error]
}
